import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardInvoiceBillingAddressRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardInvoiceBillingAddressContainerLoadable } from './OrgDashboardInvoiceBillingAddressContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardInvoiceBillingAddressRoute>,
) {
  await OrgDashboardInvoiceBillingAddressContainerLoadable.load();
}

export default function OrgDashboardInvoiceBillingAddressHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Change Invoice Address')}>
      <OrgDashboardInvoiceBillingAddressContainerLoadable />
    </RouteModule>
  );
}
